import { Big } from 'big.js';
import PicJob from '~/tenants/pic/model/PicJob';
import PicVirtualStagingConfig from '~/tenants/pic/performable/staging/PicVirtualStagingConfig';
import { TenantOrderLine } from '~/lib/model';
import { schema_latest_version, ZodVersionedMetadata } from '~/lib/zod';
import { PicOrderType } from '~/tenants/pic/model/PicOrder';

export default class PicVirtualStagingJob extends PicJob<typeof PicVirtualStagingConfig> {
  get performable() {
    return PicVirtualStagingConfig;
  }

  defaultValue(): ZodVersionedMetadata<(typeof PicVirtualStagingConfig)['schema']> {
    return {
      photos: 1,
      version: schema_latest_version(PicVirtualStagingConfig.schema),
    };
  }

  get eligible() {
    return this.order.metadata.type !== PicOrderType.COMMERCIAL;
  }

  revenueLines(): TenantOrderLine[] {
    let amount = new Big(0);

    for (let i = 1; i <= this.metadata.photos; i += 1) {
      if (i < 5) {
        amount = amount.plus('25');
      } else {
        amount = amount.plus('20');
      }
    }

    return [
      {
        amount,
        description: this.performable.name,
        id: this.performable.id,
      },
    ];
  }
}
